(function(){
'use strict';
const root=document.getElementById('bb-home');
const esc=value=>String(value??'').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format((n||0)/100);
const route=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
const base=route.endsWith('/')?route:route+'/';
document.querySelectorAll('.bb-mobile-drawer a').forEach(link=>link.addEventListener('click',()=>{const details=link.closest('details');if(details)details.open=false;}));
async function refreshBag(){
 try{
  const res=await fetch(base+'cart.js',{credentials:'same-origin'});
  if(!res.ok)return;
  const cart=await res.json();
  document.querySelectorAll('.bb-bag b').forEach(node=>node.textContent=cart.item_count);
  document.dispatchEvent(new CustomEvent('bb:cart-updated',{detail:{itemCount:cart.item_count}}));
 }catch(error){/* cart confirmation remains visible */}
}
document.querySelectorAll('[data-countdown]').forEach(el=>{
 const end=Date.parse(el.dataset.countdown);
 function update(){
  const diff=Math.max(0,Math.floor((end-Date.now())/1000)),days=Math.floor(diff/86400),hours=Math.floor(diff%86400/3600),mins=Math.floor(diff%3600/60);
  el.textContent=Date.now()>=end?'Time reached':days+'d '+hours+'h '+mins+'m';
 }
 update();setInterval(update,60000);
});
if(!root)return;
const node=document.getElementById('bb-live-products');
let data;
try{data=node?JSON.parse(node.textContent):null;}catch(error){return;}
const preview=root.dataset.previewMode==='true';
const orderingEnabled=root.dataset.boxCheckoutEnabled==='true';
const openAt=Date.parse(root.dataset.reveal),closeAt=Date.parse(root.dataset.cutoff);
const canOrder=()=>orderingEnabled&&(preview||(Date.now()>=openAt&&Date.now()<closeAt));
const bucketOrder=button=>button.dataset.bbBucket==='true';
function setMessage(where,message,html=false){const el=root.querySelector(where);if(!el)return;if(html)el.innerHTML=message;else el.textContent=message;el.setAttribute('role','status');}
function markAdded(button,where){
 button.disabled=false;button.textContent=button.dataset.originalText||'Add to Bag';
 setMessage(where,'Added to your bag. <a href="/cart" style="text-decoration:underline;font-weight:700">View bag</a> or keep shopping.',true);
 refreshBag();
}
async function addItems(items,button,where){
 if(!canOrder()){setMessage(where,'Ordering is currently closed.');return;}
 button.dataset.originalText=button.dataset.originalText||button.textContent;
 button.disabled=true;button.textContent='Adding…';
 try{
  const response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
  if(!response.ok){const info=await response.json().catch(()=>({}));throw new Error(info.description||info.message||'Unable to add your selection.');}
  markAdded(button,where);
 }catch(error){button.disabled=false;button.textContent=button.dataset.originalText;setMessage(where,error.message||'Unable to add your selection.');}
}
root.querySelectorAll('.bb-single-add').forEach(button=>button.addEventListener('click',async()=>{
 if((!canOrder()&&!bucketOrder(button))||button.disabled)return;
 let note=button.parentElement.querySelector('.bb-add-confirmation');
 if(!note){note=document.createElement('p');note.className='bb-add-confirmation';button.insertAdjacentElement('afterend',note);}
 note.setAttribute('role','status');note.textContent='';
 const variant=Number(button.dataset.variant);
 const label=button.textContent;button.disabled=true;button.textContent='Adding…';
 try{
  if(!Number.isInteger(variant)||variant<=0)throw Error('Item is currently unavailable.');
  const quantity=Math.max(1,Math.trunc(Number(button.parentElement.querySelector('.bb-item-qty')?.value)||1));
  const payload={id:variant,quantity};
  const flavorChoices=button.closest('.bb-product')?.querySelectorAll('.bb-bucket-flavor');
  if(flavorChoices?.length){
   const selected=[...flavorChoices].filter(input=>input.checked).map(input=>input.value);
   if(selected.length===0)throw Error('Please choose at least one flavor. You can select both.');
   if(selected.includes('Selection pending weekly reveal')&&selected.length>1)throw Error('Choose confirmed flavors or the after-reveal option, not both.');
   payload.properties={
     'Brownie / Blondie flavors':selected.join(' + '),
     'Flavor mix':selected.length===2?'Both weekly flavors':'Single flavor'
   };
  }
  const response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[payload]})});
  if(!response.ok){const error=await response.json().catch(()=>({}));throw Error(error.description||error.message||'Could not add item.');}
  note.innerHTML='Added to your bag. <a href="/cart" style="text-decoration:underline;font-weight:700">View bag</a> or keep shopping.';
  refreshBag();
 }catch(error){note.textContent=error.message||'Unable to add item.';}
 finally{button.textContent=label;button.disabled=false;}
}));
if(!data||!Array.isArray(data.cookies)||!Array.isArray(data.bars))return;
const cookie={size:4,chosen:{}};
const weekend={cookie:{},bar:{}};
const pick=(list)=>Object.values(list).reduce((a,b)=>a+b,0);
const look=(type,id)=>(type==='bar'?data.bars:data.cookies).find(item=>String(item.id)===String(id));
function stepper(items,selection,key,max){
 return items.map(item=>{
  const n=selection[item.id]||0,limit=pick(selection)>=max;
  return '<div class="bb-count-row"><div><strong>'+esc(item.title)+'</strong><div class="bb-tiny">'+money(item.price)+'</div></div>'+
   '<div class="bb-stepper"><button type="button" data-bb-pick="'+key+'" data-id="'+item.id+'" data-delta="-1" '+(!n?'disabled':'')+' aria-label="Remove '+esc(item.title)+'">−</button><span>'+n+'</span><button type="button" data-bb-pick="'+key+'" data-id="'+item.id+'" data-delta="1" '+(limit||!item.available?'disabled':'')+' aria-label="Add '+esc(item.title)+'">+</button></div></div>';
 }).join('');
}
function itemLines(items,selection){
 return items.filter(item=>selection[item.id]).map(item=>'<li><span>'+selection[item.id]+' × '+esc(item.title)+'</span><span>'+money(selection[item.id]*item.price)+'</span></li>');
}
function raw(items,chosen){return items.reduce((total,item)=>total+(chosen[item.id]||0)*item.price,0);}
function showCookie(){
 const list=root.querySelector('[data-cookie-options]');if(!list)return;
 list.innerHTML=stepper(data.cookies,cookie.chosen,'cookie',cookie.size);
 const qty=pick(cookie.chosen),fulfilled=qty===cookie.size;
 root.querySelector('[data-cookie-progress]').textContent=qty+' of '+cookie.size+' cookies selected';
 root.querySelector('[data-cookie-summary]').innerHTML=itemLines(data.cookies,cookie.chosen).join('')||'<li>Choose your favorites to start.</li>';
 root.querySelector('[data-cookie-total]').textContent=money(raw(data.cookies,cookie.chosen));
 root.querySelector('[data-cookie-add]').disabled=!canOrder()||!fulfilled;
}
function showWeekend(){
 const cookies=root.querySelector('[data-weekend-cookie-options]');if(!cookies)return;
 cookies.innerHTML=stepper(data.cookies,weekend.cookie,'weekend-cookie',3);
 root.querySelector('[data-weekend-bar-options]').innerHTML=stepper(data.bars,weekend.bar,'weekend-bar',2);
 root.querySelector('[data-weekend-cookie-progress]').textContent=pick(weekend.cookie)+' of 3 cookies';
 root.querySelector('[data-weekend-bar-progress]').textContent=pick(weekend.bar)+' of 2 bars';
 root.querySelector('[data-weekend-summary]').innerHTML=[...itemLines(data.cookies,weekend.cookie),...itemLines(data.bars,weekend.bar)].join('')||'<li>Choose three cookies and two bars to start.</li>';
 root.querySelector('[data-weekend-total]').textContent=money(raw(data.cookies,weekend.cookie)+raw(data.bars,weekend.bar));
 root.querySelector('[data-weekend-add]').disabled=!canOrder()||pick(weekend.cookie)!==3||pick(weekend.bar)!==2;
}
root.addEventListener('click',e=>{
 const button=e.target.closest('[data-bb-pick]');
 if(!button)return;
 const kind=button.dataset.bbPick,delta=Number(button.dataset.delta),id=button.dataset.id;
 const arr=kind==='cookie'?cookie.chosen:kind==='weekend-bar'?weekend.bar:weekend.cookie;
 const max=kind==='cookie'?cookie.size:kind==='weekend-bar'?2:3;
 const item=look(kind==='weekend-bar'?'bar':'cookie',id);
 if(!item||!item.available)return;
 const next=(arr[id]||0)+delta;
 if(next<0||(delta>0&&pick(arr)>=max))return;
 if(next===0)delete arr[id];else arr[id]=next;
 setMessage(kind==='cookie'?'[data-cookie-error]':'[data-weekend-error]','');
 if(kind==='cookie')showCookie();else showWeekend();
});
root.querySelectorAll('[data-cookie-sizes] [data-size]').forEach(button=>button.addEventListener('click',()=>{
 cookie.size=Number(button.dataset.size);cookie.chosen={};
 root.querySelectorAll('[data-cookie-sizes] [data-size]').forEach(tab=>tab.setAttribute('aria-pressed',String(tab===button)));
 setMessage('[data-cookie-error]','');showCookie();
}));
function groupItems(parts,title){
 const ref='BB-'+Date.now().toString(36)+'-'+Math.floor(Math.random()*100000).toString(36);
 return parts.flatMap(({items,selected})=>items.filter(item=>selected[item.id]>0).map(item=>({
  id:Number(item.id),quantity:selected[item.id],properties:{'Box':title,'Box reference':ref}
 })));
}
const cookieButton=root.querySelector('[data-cookie-add]');
if(cookieButton)cookieButton.addEventListener('click',()=>{
 if(pick(cookie.chosen)!==cookie.size)return;
 addItems(groupItems([{items:data.cookies,selected:cookie.chosen}],'Cookie Box • '+cookie.size),cookieButton,'[data-cookie-error]');
});
const weekendButton=root.querySelector('[data-weekend-add]');
if(weekendButton)weekendButton.addEventListener('click',()=>{
 if(pick(weekend.cookie)!==3||pick(weekend.bar)!==2)return;
 addItems(groupItems([{items:data.cookies,selected:weekend.cookie},{items:data.bars,selected:weekend.bar}],'Your Weekend, Your Box'),weekendButton,'[data-weekend-error]');
});
showCookie();showWeekend();
})();